import React, { useEffect, useState } from "react";
import { Table, Rate, Tag, Typography } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import PageHeader from "./common/PageHeader";
import InfoHint from "./common/InfoHint";
import { getTechnicianStats } from "../network/api";
import { notify, serverError } from "../utils/notify";

const { Text } = Typography;

// D3 — supervisor scorecard: per-technician visit & rating summary.
export default function Team() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getTechnicianStats()
      .then(setData)
      .catch((e) => notify.error(serverError(e, "Failed to load team stats")))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      title: "Technician",
      dataIndex: "name",
      render: (v, r) => (
        <span>
          <Text strong>{v || "—"}</Text>
          {r.email ? <div><Text type="secondary" style={{ fontSize: 12 }}>{r.email}</Text></div> : null}
        </span>
      ),
    },
    { title: <span>Completed<InfoHint title="Number of visits this technician has marked complete." /></span>, dataIndex: "completed", align: "center", render: (n) => <Tag color="blue">{n || 0}</Tag> },
    { title: <span>Verified<InfoHint title="Of the completed visits, how many a supervisor has reviewed and signed off." /></span>, dataIndex: "verified", align: "center", render: (n) => <Tag>{n || 0}</Tag> },
    {
      title: <span>Avg rating<InfoHint title="Average supervisor rating across this technician's verified visits, with the number of ratings in brackets." /></span>,
      dataIndex: "avgRating",
      render: (v, r) =>
        v ? (
          <span>
            <Rate disabled allowHalf value={v} style={{ fontSize: 14 }} />{" "}
            <Text type="secondary">{v} ({r.ratingCount})</Text>
          </span>
        ) : (
          <Text type="secondary">Not yet rated</Text>
        ),
    },
  ];

  return (
    <div>
      <PageHeader title="Team Performance" subtitle="Technician visit & rating summary" tooltip="Scorecard of each technician's field activity — visits completed, how many were verified by a supervisor, and their average rating. Use it to spot who needs support or recognition." icon={<TeamOutlined />} />
      <Table
        rowKey="technician"
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={false}
        locale={{ emptyText: "No technician activity yet" }}
      />
    </div>
  );
}
